const data = {
    text: [
        `UNDER CONSTRUCTION`
     ],
    links: [
    ],
    commands: [
    ]
};

export default data;